import React from 'react';
import './MinimalFooter.css';

function MinimalFooter() {
  return (
    <footer className="minimal-footer">
      <div className='footer-bottom'>
        <p>FOMEJE © {new Date().getFullYear()} | All Rights Reserved</p>
      </div>
      <div className="bug-report-section">
        <small>
          Found a bug? Contact <a href="mailto:ali.issaoui17@gmail.com" className="bug-report-link">Ali Issaoui</a>
        </small>
      </div>
    </footer>
  );
}

export default MinimalFooter; 